import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class RiverSpring4TerrainTileEntity extends TileEntity {
	public static readonly frameName = FrameName.RIVER_SPRING4;
}

export default RiverSpring4TerrainTileEntity;
